export default __webpack_public_path__ + "static/media/react.c2f2bc82.svg";